import React, { Component } from "react";

class Warehouse extends Component {
    state = {}
    render() {
        return (
            <div>
                jhsdugsuyicgycgsg
            </div>
        );
    }
}

export default Warehouse;